import React from "react";
import {FormHeader, FormSubHeader, H1, Small} from "../styles/globalStyles";

export default ({
    heading,
    subHeading
}) => {

    return(
        <>
             <FormHeader>
                 <H1>
                    {heading}
                 </H1>
             </FormHeader>

             <FormSubHeader>
                <Small>
                    {subHeading}
                </Small>
             </FormSubHeader>
        
        </>
    );
}